export default {
  TOGGLE_DAY: 'TOGGLE_DAY',
  TOGGLE_SLOT: 'TOGGLE_SLOT',
  SET_ACTIVE_DAY_SLOT: 'SET_ACTIVE_DAY_SLOT',
  RESET_SCHEDULER_STATE: 'RESET_SCHEDULER_STATE',
    SET_ADDRESS: 'SET_ADDRESS',
    RESCHEDULE_EVENT: 'RESCHEDULE_EVENT',
}